// extracted by mini-css-extract-plugin
export default {"Separator":"PCf3wrhPfE0jpWkv62Ad","Separator_OrLabel":"EIZusNdQEwPUCPInbxI6"};